declare const STAGE: string;
declare const ROLLBAR_ACCESS_TOKEN_PUBLIC_KEY: string;

export default {
	accessToken: ROLLBAR_ACCESS_TOKEN_PUBLIC_KEY,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: window["rollbarIgnore"],
	payload: {
		environment: STAGE,
	},
};
